import {
	useInfiniteQuery,
	type InfiniteData,
	type UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import {
	getAttributeVocabularies,
	getAttributeVocabulariesEndpoint,
	type QueryError,
	type GetAttributeVocabulariesResult,
	type GetAttributeVocabulariesRequestOptions,
} from '../getAttributeVocabularies';
export * from '../getAttributeVocabularies';

export type GetAttributeVocabulariesResultInfiniteData =
	InfiniteData<GetAttributeVocabulariesResult>;

// page params are handled via the infinite query `pageParams`
export type GetAttributeVocabulariesQueryParams = Omit<
	GetAttributeVocabulariesRequestOptions,
	'startIndex' | 'stopIndex'
>;

export type GetAttributeVocabulariesQueryKey = [
	string,
	GetAttributeVocabulariesQueryParams,
];

export type GetAttributeVocabulariesQueryOptions = Omit<
	UseInfiniteQueryOptions<
		GetAttributeVocabulariesResult,
		QueryError,
		GetAttributeVocabulariesResult,
		GetAttributeVocabulariesResult,
		GetAttributeVocabulariesQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const GetAttributeVocabulariesReactQueryKey =
	getAttributeVocabulariesEndpoint;

/**
 * react-query wrapper for `getAttributeVocabularies`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetAttributeVocabularies = (
	queryKeyParams: GetAttributeVocabulariesQueryParams = {},
	options?: GetAttributeVocabulariesQueryOptions,
) =>
	useInfiniteQuery<
		GetAttributeVocabulariesResult,
		QueryError,
		GetAttributeVocabulariesResult,
		GetAttributeVocabulariesQueryKey
	>({
		queryKey: [getAttributeVocabulariesEndpoint, queryKeyParams],
		queryFn: ({queryKey, pageParam, signal}) =>
			getAttributeVocabularies({...queryKey[1], ...pageParam}, signal),
		...options,
	});

export default useReactQueryGetAttributeVocabularies;
